"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserOfficeHours_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Location_1 = require("./Location");
var User_1 = require("./User");
var UserOfficeHours_Factory = /** @class */ (function () {
    function UserOfficeHours_Factory() {
    }
    UserOfficeHours_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Location: Location_1.Location_Factory.CreateIncoming(model.Location),
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UserId: model.UserId,
            Users: User_1.User_Factory.CreateIncoming(model.Users),
        };
        return result;
    };
    UserOfficeHours_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Location: Location_1.Location_Factory.CreateOutgoing(model.Location),
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UserId: model.UserId,
            Users: User_1.User_Factory.CreateOutgoing(model.Users),
        };
        return result;
    };
    return UserOfficeHours_Factory;
}());
exports.UserOfficeHours_Factory = UserOfficeHours_Factory;
